'use strict';

import React from 'react';

import appConstants from 'constants/appConstants';

import teamActions from 'actions/TeamActionCreators';
import teamStore from 'stores/TeamStore';
import reportsActions from 'actions/ReportsActionCreators';
import reportsStore from 'stores/ReportsStore';
import modalActions from 'actions/ModalActionCreators';

import PageSection from 'components/base/PageSection';
import List from 'components/base/list-components/List';
import ListSection from 'components/base/list-components/ListSection';
import ListItem from 'components/base/list-components/ListItem';
import Avatar from 'components/base/Avatar';

import ConfirmationModalContent from 'components/base/ConfirmationModalContent';

import _ from 'underscore';
import utils from 'services/utils';
import personUtils from 'services/people/personUtils';
import moment from 'moment';

const propTypes = {};

class AuditLogsWidget extends React.Component {

    constructor(props) {
        super(props);
        this.handleDownload = this.handleDownload.bind(this);
        this.onReportChange = this.onReportChange.bind(this);
        this.state = {
            reports: {},
        };
    }
    
    componentDidMount() {
        reportsStore.addChangeListener(this.onReportChange);
    }

    componentWillUnmount() {
        reportsStore.removeChangeListener(this.onReportChange);
    }

    onReportChange() {
        const state = reportsStore.getReportsState();

        this.setState({reports: state});

        if (state.error) {
            setTimeout(function () {
                modalActions.showModal(
                    <ConfirmationModalContent
                        message="An error has occurred with your file download"
                        callbackFunction={null}
                    />
                );
            }.bind(this), 0);
        }
    }

    handleDownload(reportType) {

        switch (reportType) {
        case appConstants.reports.PERSONAL_CHANGES_AUDIT_REPORT:
            reportsActions.getPersonalChangesAuditReport({
                reportType,
                browserTimeOffset: moment().utcOffset(),
            });
            break;
        case appConstants.reports.LEAVE_AUDIT_REPORT:
            reportsActions.getLeaveAuditReport({
                reportType,
                browserTimeOffset: moment().utcOffset(),
            });
            break;
        case appConstants.reports.MAINTENANCE_AUDIT_REPORT:
            reportsActions.getMaintenanceAuditReport({
                reportType,
                browserTimeOffset: moment().utcOffset(),
            });
            break;
        case appConstants.reports.ACTIVATION_REPORT:
            reportsActions.getActivationReport({
                reportType,
                browserTimeOffset: moment().utcOffset(),
            });
            break;
        }
    }
    
    render() {
        return (
            <PageSection id="audit-logs-widget">
                <List
                    icon="icon-audit-reports"
                    heading="Audit Reports"
                >
                    <ListSection maxItems={5}>
                        <ListItem
                            heading="Profile changes audit report"
                            onClick={this.handleDownload.bind(this, appConstants.reports.PERSONAL_CHANGES_AUDIT_REPORT)}
                            id={"report-{0}".format(appConstants.reports.PERSONAL_CHANGES_AUDIT_REPORT)}
                            downloading={this.state.reports[appConstants.reports.PERSONAL_CHANGES_AUDIT_REPORT] ? this.state.reports[appConstants.reports.PERSONAL_CHANGES_AUDIT_REPORT].loading : false}
                        />
                        <ListItem
                            heading="Leave applications audit report"
                            onClick={this.handleDownload.bind(this, appConstants.reports.LEAVE_AUDIT_REPORT)}
                            id={"report-{0}".format(appConstants.reports.LEAVE_AUDIT_REPORT)}
                            downloading={this.state.reports[appConstants.reports.LEAVE_AUDIT_REPORT] ? this.state.reports[appConstants.reports.LEAVE_AUDIT_REPORT].loading : false}
                        />
                        <ListItem
                            heading="Maintenance audit report"
                            onClick={this.handleDownload.bind(this, appConstants.reports.MAINTENANCE_AUDIT_REPORT)}
                            id={"report-{0}".format(appConstants.reports.MAINTENANCE_AUDIT_REPORT)}
                            downloading={this.state.reports[appConstants.reports.MAINTENANCE_AUDIT_REPORT] ? this.state.reports[appConstants.reports.MAINTENANCE_AUDIT_REPORT].loading : false}
                        />
                        <ListItem
                            heading="Activation report"
                            onClick={this.handleDownload.bind(this, appConstants.reports.ACTIVATION_REPORT)}
                            id={"report-{0}".format(appConstants.reports.ACTIVATION_REPORT)}
                            downloading={this.state.reports[appConstants.reports.ACTIVATION_REPORT] ? this.state.reports[appConstants.reports.ACTIVATION_REPORT].loading : false}
                        />
                    </ListSection>
                </List>     
            </PageSection>
        );
    }
}

AuditLogsWidget.propTypes = propTypes;

export default AuditLogsWidget; 
